import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blush/30 via-ivory to-champagne/15 px-6" data-testid="admin-login-page">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md rounded-[2rem] bg-ivory border border-champagne/30 p-9 md:p-11 shadow-xl">
        <div className="flex flex-col items-center text-center">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-blush/30 text-bronze"><Lock size={22} /></span>
          <p className="mt-5 font-heading text-2xl tracking-[0.12em] text-ink">LEAH THAMES</p>
          <p className="mt-1 label-eyebrow">Admin Studio</p>
        </div>

        {error && <p data-testid="admin-login-error" className="mt-6 rounded-xl bg-destructive/10 text-destructive px-4 py-3 text-sm text-center">{error}</p>}

        <div className="mt-7 space-y-4">
          <div>
            <label className="label-eyebrow">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email"
              className="mt-2 w-full rounded-2xl bg-white border border-champagne/40 px-5 py-3.5 font-body text-sm focus:outline-none focus:border-bronze" />
          </div>
          <div>
            <label className="label-eyebrow">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password"
              className="mt-2 w-full rounded-2xl bg-white border border-champagne/40 px-5 py-3.5 font-body text-sm focus:outline-none focus:border-bronze" />
          </div>
        </div>

        <button type="submit" disabled={loading} data-testid="admin-login-submit"
          className="mt-7 w-full rounded-full bg-bronze px-8 py-4 font-body text-sm font-semibold text-ivory hover:bg-ink transition-colors disabled:opacity-60">
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
